const COUNTRY_CALLING_CODE_LIST = {
  JPN: 81,
  CHN: 86
}

export default {
  COUNTRY_CALLING_CODE_LIST
}
